import { render, staticRenderFns } from "./data-loader.page.vue?vue&type=template&id=2823a87e&scoped=true&"
import script from "./data-loader.page.vue?vue&type=script&lang=js&"
export * from "./data-loader.page.vue?vue&type=script&lang=js&"
import style0 from "./data-loader.page.vue?vue&type=style&index=0&id=2823a87e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823a87e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
